import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import quoteSvg from 'resources/svg/icons/quote.svg'

export const Item = styled.div`
  text-align: center;

  .item {
    &__review,
    &__author {
      font: ${font('default', 'light', '20px/1.5')};
    }

    &__review {
      padding: 0 70px 20px;
      position: relative;

      &::after,
      &::before {
        content: '';
        width: 41px;
        height: 30px;
        display: block;
        position: absolute;
        background: url(${quoteSvg}) no-repeat center;
      }

      &::before {
        top: 0;
        left: 35px;
      }

      &::after {
        bottom: 0;
        right: 35px;
        transform: rotate(180deg);
      }
    }

    &__rating {
      margin: 20px 0 10px;

      svg {
        padding: 0 5px;
        width: 14px;
        fill: ${props => props.theme.palette.general.strong};
      }
    }
  }
`
